export function initNav() {
  document.body.addEventListener("click", (e) => {
    const button = e.target?.closest(".menu-toggle")
    if (button) toggleMenu()
  })
  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && document.body.classList.contains("-menu-open"))
      toggleMenu()
  })
}

async function toggleMenu(alsoToggleMenu) {
  const open = document.body.classList.contains("-menu-open")
  document.body.classList.toggle("-menu-open", !open)
  //window.scrollTo({ top: 0, behavior: "smooth" })

  if (!alsoToggleMenu && document.body.classList.contains("-aside-open"))
    toggleAside(true)

  if (open) {
    document.body.classList.add("-menu-closing")
    setTimeout(() => {
      document.body.classList.remove("-menu-closing")
    }, window.TOGGLE_TIMING)
  }
}

export function initAside() {
  document.body.addEventListener("click", (e) => {
    const button = e.target?.closest(".aside-toggle")
    if (button) toggleAside()
  })
  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && document.body.classList.contains("-aside-open"))
      toggleAside()
  })
}

async function toggleAside(alsoToggleAside) {
  const open = document.body.classList.contains("-aside-open")
  document.body.classList.toggle("-aside-open", !open)
  window.scrollTo({ top: 0, behavior: "smooth" })

  if (!alsoToggleAside && document.body.classList.contains("-menu-open"))
    toggleMenu(true)

  if (open) {
    document.body.classList.add("-aside-closing")
    setTimeout(() => {
      document.body.classList.remove("-aside-closing")
    }, window.TOGGLE_TIMING)
  }
}
